import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-518b25b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chapter-list-menu" }
const _hoisted_2 = {
  key: 0,
  class: "top-seat"
}
const _hoisted_3 = { class: "btn-box" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "colour colour-mulu" }, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode("目录列表"),
    _createVNode(_component_el_drawer, {
      modelValue: $setup.popup,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.popup) = $event)),
      size: "auto",
      direction: "ltr",
      "with-header": false
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" 顶部占位符 "),
        ($setup.config.android)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_el_menu, {
          class: "chapter-list",
          "active-text-color": "#ee0a24",
          "default-active": String($setup.chapterIndex),
          onSelect: $setup.change_chapter
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chapterList, (k, i) => {
              return (_openBlock(), _createBlock(_component_el_menu_item, {
                index: String(i),
                key: k.chapterId
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(k.chapterName), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createVNode($setup["Seat"], { height: "4rem" })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["default-active"]),
        _createCommentVNode("翻页按钮"),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            class: "btn",
            type: "warning",
            plain: "",
            onClick: _withModifiers($setup.before, ["stop"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('page.before')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]),
          _createVNode(_component_el_button, {
            class: "btn",
            type: "success",
            plain: "",
            onClick: _withModifiers($setup.next, ["stop"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('page.next')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.popup]
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createCommentVNode("目录按钮"),
    _withDirectives(_createElementVNode("div", {
      class: "show-menu-btn",
      onClick: _withModifiers($setup.button_click, ["stop"])
    }, [..._hoisted_6], 8 /* PROPS */, _hoisted_4), [
      [_vShow, $setup.config.browseTop]
    ])
  ]))
}